// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-21T22:00:29.120Z
// Property: Lumina Mountain Vista (ID: 6767906449166301)
// Collections: 25 amenities, 6 floorplans (live), 23 photos, 49 POIs, 3 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166301",
  "property_external_id": "bd8yvq9",
  "property_zillow_url": "https://www.zillow.com/apartments/mesa-az/lumina-mountain-vista/CjjCKC/",
  "property_apartments_url": "https://www.apartments.com/lumina-mountain-vista-mesa-az/bd8yvq9/",
  "property_google_business_url": "https://www.google.com/maps/place/Lumina+Mountain+Vista/data=!4m2!3m1!1s0x0:0x1a7bd9d21023eef?sa=X&ved=2ahUKEwjqnN2x36eSAxWTc_UHHQ5JC90Q_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": "https://au.linkedin.com/company/lumina-vista",
  "property_hubspot_id": "40255796363",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "283LMV",
  "property_status": null,
  "property_slug": "lumina-mountain-vista",
  "property_name": "Lumina Mountain Vista",
  "property_website_url": "https://www.luminamountainvista.com/",
  "property_domain": "https://www.luminamountainvista.com/",
  "property_address": "10631 East Southern Avenue",
  "property_full_address": "10631 E Southern Ave, Mesa, AZ 85209",
  "property_address_1": "10631 E Southern Ave",
  "property_address_2": null,
  "property_address_city": "Mesa",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85209",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "East Mesa",
  "property_address_latitude": "33.3907317",
  "property_address_longitude": "-111.6014408",
  "property_email": null,
  "property_phone": "(623) 292-2665",
  "property_call_tracking_phone": "844-888-1608",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Lumina Mountain Vista in Mesa, AZ, your ideal home awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans. Enjoy exclusive amenities like a refreshing pool, state-of-the-art fitness center, and vibrant pet play area. Experience mountain living with modern conveniences—your adventure starts here!",
  "property_long_description": "Welcome to **Lumina Mountain Vista**, Mesa, AZ’s premier apartment community, where luxury meets convenience! Discover a wide range of thoughtfully designed floor plans, including **one, two, and three-bedroom** apartments, perfect for any lifestyle. Each residence features stunning **granite countertops**, modern **stainless steel appliances**, spacious **walk-in closets**, and cozy **balconies or patios** with breathtaking views.\n\nAt Lumina Mountain Vista, we prioritize your comfort and community. Enjoy a resort-style **pool**, invigorating **fitness center**, and a welcoming **clubhouse** where you can socialize and unwind. Families will appreciate our engaging **playground** and **dog park**, while professionals can make use of our **business center** and **conference rooms**. With **controlled access** and on-site management, you can rest easy knowing your security and comfort are our top priorities.\n\nExplore an array of premium amenities designed for your active lifestyle, including a **hot tub**, **spa**, and outdoor **grill** areas. Plus, with conveniences like **door-to-door trash pickup**, **EV charging stations**, and **online services**, we ensure that your life here is as stress-free as possible. \n\nJoin us for planned social activities and enjoy our vibrant community spaces, including the **courtyard**, **sundeck**, and **multi-use room**. Lumina Mountain Vista is also **wheelchair accessible** and smoke-free, offering a welcoming environment for all.  \n\nFind your new home today—**browse our availability** or **schedule a tour** to visit our exquisite community! Experience the unmatched lifestyle that awaits you at Lumina Mountain Vista.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f6b9b-0846-772f-8248-f9633497bfbd.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with cabanas and lounge chairs in front of apartment buildings.",
    "public_id": "019f6b9b-0846-772f-8248-f9633497bfbd",
    "storage_key": "property/6767906449166301/019f6b9b-0846-772f-8248-f9633497bfbd.webp",
    "width": 1920,
    "height": 1080
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166301/019ffc3a-642c-7127-b435-f230559cd14e.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc3a-642c-7127-b435-f230559cd14e",
    "storage_key": "property/6767906449166301/019ffc3a-642c-7127-b435-f230559cd14e.m4v",
    "thumbnail_key": "property/6767906449166301/019ffc3a-642c-7127-b435-f230559cd14e_thumb.webp",
    "size_bytes": 15613026,
    "classification": "Apartment",
    "title": "Modern Apartment Interior Tour",
    "description": "Explore the spacious and stylish interiors of our apartments, featuring modern kitchens, comfortable bedrooms, and elegant living spaces."
  },
  "property_total_units": "300",
  "property_year_built": "2022",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.33333333333334",
  "property_admin_fee": "300",
  "property_application_fee": "70",
  "property_fees_deposit_info": "Security Deposit\n$500 -1 Month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Dogs and cats allowed.",
  "property_pet_policy_description": "Dogs and cats allowed. One-time pet fee: $400 per pet. Monthly pet rent: $40 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://luminiamountainvista.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcluminamountainvista",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-a1d0-7304-9293-d78f786cd557.webp",
  "property_primary_logo_media": {
    "alt_text": "Lumina Mountain View logo",
    "public_id": "019d02c7-a1d0-7304-9293-d78f786cd557",
    "storage_key": "property/6767906449166301/019d02c7-a1d0-7304-9293-d78f786cd557.webp",
    "width": 559,
    "height": 200
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-8d2e-764d-befe-9f804e8a48d9.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c7-8d2e-764d-befe-9f804e8a48d9",
    "storage_key": "property/6767906449166301/019d02c7-8d2e-764d-befe-9f804e8a48d9.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-a1d0-7304-9293-d78f786cd557.webp",
  "property_fav_icon_media": {
    "alt_text": "Lumina Mountain View logo",
    "public_id": "019d02c7-a1d0-7304-9293-d78f786cd557",
    "storage_key": "property/6767906449166301/019d02c7-a1d0-7304-9293-d78f786cd557.webp",
    "width": 559,
    "height": 200
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-bbac-7221-a0ab-97eb5e169225.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Generic blank image",
    "public_id": "019d02c7-bbac-7221-a0ab-97eb5e169225",
    "storage_key": "property/6767906449166301/019d02c7-bbac-7221-a0ab-97eb5e169225.webp",
    "width": 559,
    "height": 200
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-a1d0-7304-9293-d78f786cd557.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Lumina Mountain View logo",
    "public_id": "019d02c7-a1d0-7304-9293-d78f786cd557",
    "storage_key": "property/6767906449166301/019d02c7-a1d0-7304-9293-d78f786cd557.webp",
    "width": 559,
    "height": 200
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "795 - 1288",
  "property_sqft_min": "795",
  "property_sqft_max": "1288",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": "1979",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/LuminaMountainVista",
  "property_instagram_url": "https://www.instagram.com/luminamountainvista/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ1e5VHnuxK4cR7z4CIZ29pwE",
  "property_youtube_url": "https://www.youtube.com/watch?t=527&v=Kg1x-z3mRxg",
  "property_yelp_url": "https://www.yelp.com/biz/the-aster-at-mountain-vista-mesa",
  "property_tiktok_url": "https://www.tiktok.com/discover/lumina-mountain-vista-apartment-mesa-az",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Lumina Mountain Vista",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Home Today",
  "property_home_amenities_blurb": "Welcome to Lumina Mountain Vista, nestled in beautiful Mesa, AZ, where modern living meets vibrant community life. Choose from spacious one, two, or three-bedroom apartments, and enjoy amenities like a sparkling pool, state-of-the-art fitness center, and inviting pet-friendly spaces. Experience comfort and convenience like never before!",
  "property_home_floorplans_blurb": "Welcome to Lumina Mountain Vista in Mesa, AZ, where comfort meets style. Our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of space and modern amenities. Ready to elevate your lifestyle? Browse our available homes and find the ideal floor plan that suits your needs.",
  "property_home_gallery_blurb": "At Lumina Mountain Vista in Mesa, AZ, choose from spacious one, two, or three-bedroom floor plans designed for modern living. Immerse yourself in a community filled with luxurious amenities like a refreshing pool, fitness center, and pet-friendly spaces. Picture yourself living here, where comfort meets vibrant lifestyle!",
  "property_home_neighborhood_blurb": "At Lumina Mountain Vista in Mesa, AZ, vibrant living meets adventure. Beyond our diverse one, two, and three-bedroom floor plans, discover a world of recreational delights, from Usery Mountain Regional Park to Red Mountain Park. Embrace a community where wellness and nature thrive, just steps from your new home.",
  "property_home_reviews_blurb": "At Lumina Mountain Vista in Mesa, AZ, our residents love the spacious views and well-maintained grounds, perfect for families. \"The view is beautiful, and the large grass area is great for kids to play near home.\" Join our community and experience the exceptional service we’re proud of!",
  "property_neighborhood_blurb": "At Lumina Mountain Vista, vibrant Mesa living unfolds at your doorstep. Venture to nearby parks like Usery Mountain and Red Mountain, or catch a game at Skyline Track and Field. With easy access to community hubs like Mesa Community College and the East Valley YMCA, life here is both enriching and exhilarating.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Lumina Mountain Vista in Mesa, AZ, enjoy luxurious living where comfort meets convenience. Dive into our sparkling pool, stay active in the fitness center, or unwind in the serene courtyard. With spacious floor plans and a pet-friendly environment, your perfect home awaits. Experience vibrant community life today!",
  "property_applynow_blurb": "Experience the allure of Lumina Mountain Vista in Mesa, AZ, where modern living meets limitless comfort. Choose from spacious one, two, or three-bedroom floor plans, and unwind with amenities like a refreshing pool, fully-equipped fitness center, and serene pet play areas. Your perfect apartment is just a click away; lease online today!",
  "property_contactus_blurb": "At Lumina Mountain Vista in Mesa, AZ, find your ideal living space among our thoughtfully designed one, two, and three-bedroom floor plans. Each home reflects modern style and comfort, perfect for your lifestyle. Have questions? Our leasing team is ready to assist you—reach out today and start your journey!",
  "property_faqs_blurb": "At Lumina Mountain Vista in Mesa, AZ, our diverse floor plans cater to every lifestyle—choose from cozy one-bedroom retreats to spacious three-bedroom homes. Curious about what makes our community special? Navigate to our FAQs page for insightful answers to your pressing questions and elevate your living experience.",
  "property_floorplans_blurb": "At Lumina Mountain Vista in Mesa, AZ, your ideal living space awaits. Choose from stylish one, two, or three-bedroom floor plans, each designed for comfort and convenience. Browse our array of layouts and envision your new home nestled in the serene beauty of the mountains. Your perfect fit is just a click away!",
  "property_gallery_blurb": "At Lumina Mountain Vista in Mesa, AZ, lifestyle meets comfort amid stunning views. Whether you choose a cozy one-bedroom or spacious three-bedroom, our amenities like a sparkling pool, fitness center, and pet play area elevate your living experience. Picture yourself surrounded by modern elegance and vibrant community life!",
  "property_interactivemap_blurb": "Welcome to Lumina Mountain Vista, where comfort meets style in the heart of Mesa, AZ. With one to three-bedroom floor plans and unparalleled amenities like a sparkling pool, fitness center, and lush dog park, your ideal home awaits. Navigate our interactive community map to find the perfect space today!",
  "property_pets_blurb": "At Lumina Mountain Vista in Mesa, AZ, your furry friends are family! Our community embraces pets with a one-time fee of $400 and a monthly rent of $40 per pet. Enjoy scenic surroundings that make every walk a delight. Experience the perfect blend of comfort and adventure—just paw-some!",
  "property_referafriend_blurb": "At Lumina Mountain Vista in Mesa, AZ, our vibrant community offers spacious one, two, and three-bedroom floor plans designed for comfort and style. Great friends make great neighbors—refer a friend today and let them experience the warmth and charm of our inviting apartment community!",
  "property_residentaccess_blurb": "At Lumina Mountain Vista in Mesa, AZ, convenient living meets expansive floor plans. Choose from stylish one, two, or three-bedroom apartments tailored to your lifestyle. Enhance your experience by accessing the resident portal—pay rent, schedule maintenance, and enjoy hassle-free living right at your fingertips!",
  "property_reviews_blurb": "At Lumina Mountain Vista in Mesa, AZ, residents rave about their experiences, praising the \"exceptional staff\" and \"well-maintained\" community. With a beautiful grassy area perfect for children and a clean, reliable pool, it's no wonder why many feel at home here. See what our residents have to say about living at our community!",
  "property_created_at": "1756839130518",
  "property_scheduletour_blurb": "At Lumina Mountain Vista in Mesa, AZ, choose from expertly designed one, two, or three-bedroom floor plans that reflect modern living. Immerse yourself in a vibrant community that truly feels like home. Curious about life here? Hear directly from our residents and schedule a tour today!",
  "property_thankyou_blurb": "Thank you for reaching out! At Lumina Mountain Vista in Mesa, AZ, we offer an array of thoughtfully designed floor plans, including one, two, and three-bedroom apartments that perfectly cater to your lifestyle. Stay tuned; our team will be in touch soon to help you find your ideal home!",
  "property_virtualtours_blurb": "At Lumina Mountain Vista in Mesa, AZ, spacious floor plans await you—choose from our stylish one, two, or three-bedroom apartments tailored to your lifestyle. Experience the vibrant community and breathtaking views with a virtual tour that brings your future home to life! Your adventure starts here.",
  "property_copyright": "2025 All Rights Reserved. Lumina Mountain Vista",
  "property_seo_title_home": "Lumina Mountain Vista |  Apartments in Mesa, AZ",
  "property_seo_description_home": "Discover Lumina Mountain Vista Apartments in Mesa, AZ. Enjoy modern interiors, mountain views, and resort-style amenities near dining, parks, and shopping.",
  "property_seo_title_floorplans": "Floor Plans | Mesa, AZ Apartments For Rent",
  "property_seo_description_floorplans": "Explore one, two, and three-bedroom floor plans at Lumina Mountain Vista in Mesa, AZ, featuring modern layouts and stylish finishes.",
  "property_seo_title_amenities": "Amenities | Apartments for Rent Near Scottdale, AZ",
  "property_seo_description_amenities": "Enjoy premium amenities at Lumina Mountain Vista in Mesa, AZ, including a pool, cabanas, firepit, EV charging, and modern apartment features.",
  "property_seo_title_gallery": "Gallery | Apartments in Mesa, AZ",
  "property_seo_description_gallery": "View photos of Lumina Mountain Vista Apartments in Mesa, AZ. Explore elegant interiors, outdoor amenities, and scenic mountain surroundings.",
  "property_seo_title_virtualtours": "Virtual Tours | Apartments in Mesa, AZ",
  "property_seo_description_virtualtours": "Take a virtual tour of Lumina Mountain Vista Apartments in Mesa, AZ. Explore modern homes, open layouts, and luxury amenities online.",
  "property_seo_title_interactivemap": "Interactive Map | Apartments For Rent Near Near Phoenix",
  "property_seo_description_interactivemap": "Discover your ideal retreat at Lumina Mountain Vista, Mesa, AZ! Use our interactive map to explore spacious floor plans and amazing amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Mesa, AZ",
  "property_seo_description_neighborhood": "Explore Lumina Mountain Vista in Mesa, AZ—discover local favorites and attractions for an enriched living experience!",
  "property_seo_title_contact": "Contact Us | Apartments Near Phoenix, AZ",
  "property_seo_description_contact": "Connect with Lumina Mountain Vista in Mesa, AZ! Inquire about our one, two, and three-bedroom floor plans today to elevate your living experience!",
  "property_seo_title_faqs": "FAQs | Apartments in Mesa, AZ",
  "property_seo_description_faqs": "Find the answers to your questions about Lumina Mountain Vista in Mesa, AZ! Discover community amenities, floor plans, and more on our FAQs page.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Mesa, AZ",
  "property_seo_description_reviews": "Experience life at Lumina Mountain Vista in Mesa, AZ! Check out our residents' reviews and discover the vibrant community and modern amenities that await you.",
  "property_seo_title_applynow": "Apply Now | Apartments in Mesa, AZ",
  "property_seo_description_applynow": "Experience comfort at Lumina Mountain Vista in Mesa, AZ. Enjoy luxury amenities, spacious floor plans, and a welcoming community. Apply online today!",
  "property_seo_title_residentaccess": "Apply Now | Apartments in Mesa, AZ",
  "property_seo_description_residentaccess": "Experience comfort at Lumina Mountain Vista in Mesa, AZ. Enjoy luxury amenities, spacious floor plans, and a welcoming community. Apply online today!",
  "property_seo_title_referafriend": "Refer A Friend | Lumina Mountain Vista",
  "property_seo_description_referafriend": "Brighten your neighborhood at Lumina Mountain Vista! Refer a friend today and share the joy of living in Mesa, AZ’s stunning apartment community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Homes Near Tempe, AZ",
  "property_seo_description_scheduletour": "Schedule a tour of Lumina Mountain Vista Apartments in Mesa, AZ. Discover modern living, scenic views, and resort-style amenities.",
  "property_seo_title_privacy": "Privacy Policy | Lumina Mountain Vista",
  "property_seo_description_privacy": "Your peace of mind matters. At Lumina Mountain Vista in Mesa, AZ, learn how we safeguard your privacy. Read our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Lumina Mountain Vista",
  "property_seo_description_accessibility": "At Lumina Mountain Vista in Mesa, AZ, we prioritize digital inclusion, ensuring everyone has equal access to our vibrant community. Join us online today!",
  "property_seo_title_sitemap": "Sitemap | Lumina Mountain Vista",
  "property_seo_description_sitemap": "Uncover the layout of Lumina Mountain Vista in Mesa, AZ! Navigate effortlessly through our sitemap and find your perfect home in our vibrant community.",
  "property_seo_title_thankyou": "Pet Policy | Apartments in Mesa, AZ",
  "property_seo_description_thankyou": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions at Lumina Mountain Vista.",
  "property_seo_title_pets": "Pets | Apartments in Mesa, AZ",
  "property_seo_description_pets": "Get answers to your questions about our pet policy at Lumina Mountain Vista in Mesa, AZ. You and your furry friends will love it here!",
  "property_updated_at": "1786643116220",
  "amenities": [
    {
      "id": "custom_d1b56fd1-d80b-4a77-bfd2-97b6e8b61aaa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Resort-Style Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1d14ae81-9658-46aa-b5dc-01def3790f7f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Highly Equipped Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f19f39d1-7da4-4e4e-b118-1d688ddd5431",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Firepit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_eef49809-1ad4-4d85-9da5-741ff83b973a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Pavilion with BBQ Grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_be7955a6-ac15-431b-a526-33891e266b03",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Game Lounge with Corn Hole",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_18b36f6b-9eef-4a67-b2f9-a755330ba58d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Ping-Pong & Pool Table",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c4f39601-b924-4da2-b4d2-e936fc7c6610",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Social Lounge with Conference Room",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f375bc7c-e12e-46e9-b326-a0089fed7f8d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse with Gourmet Coffee Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_445a08db-fa31-4f83-9bd2-355240ea1565",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park and Dog Wash",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_cf690063-3776-47fe-b38e-2e84944bc1d0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Large Courtyard Areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_3c9b2846-e404-4d40-80d6-c118b8d33eff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Play Zone with Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ae6abacc-9b3a-4685-92a8-20901581ebe9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Private Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e63adc1e-80f8-42c6-8de9-4fb4c5b2914c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Kitchen Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_220650d0-279b-4cb7-aa9d-a14a78c751c2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Elegant Hardwood-Style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2737f9bf-2d8b-4654-83cf-c004cc3e6016",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet Chef Kitchen with Prep Islands & Pendant Lighting*",
      "amount": "false",
      "description": "Available in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_02910f3d-4d22-4a01-b57f-042664d766b5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Premium Designer Granite Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ff2e71f1-0a1e-4b90-a07d-f52461cb94ec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Large Undermount Kitchen Sink with Modern Faucet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c754695e-d4ea-4a39-9a6b-ab7390463a91",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Modern 2” Designer Faux Wood Blinds",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_5518f2c2-ecdc-4bf4-88c3-8c44886f2006",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Eco-friendly Dual Paned Windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ae11f760-0909-4093-9dab-2179bee164e3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Dual Vanities*",
      "amount": "false",
      "description": "Available in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_94fc096c-513c-4bf2-b926-7da7d138eebd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Large Walk-in Closets with Built-in Shelving",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c61120ba-2681-426b-b3de-9608441fcafb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Full-Sized in Home Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6e6cf2de-8800-4487-9de0-e2da87cdb83a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio & Balconies",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_482dcd6d-75d9-4ea0-8b92-7c66a4401e6f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ed8754d5-d448-4758-a892-6e512df4926e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "external_id": "false",
      "title": "Detached Garages *",
      "amount": "false",
      "description": "Available in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_bfe9444b-7e70-4cdc-b727-311b1cafeb6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01097-002b-7146-880e-82f89f3fb378.webp",
      "image_media": {
        "alt_text": "Modern leasing office reception desk with gray chairs and marble countertop at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01097-002b-7146-880e-82f89f3fb378",
        "storage_key": "property/6767906449166301/01a01097-002b-7146-880e-82f89f3fb378.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our modern leasing office, featuring a stylish reception desk with comfortable seating and a welcoming lounge area.",
      "link": "",
      "alt_text": "Modern leasing office reception desk with gray chairs and marble countertop at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39c78cbf-3235-49b0-8a24-22ec06572543",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-b8e1-7429-8c48-a08cd432befd.webp",
      "image_media": {
        "alt_text": "Modern communal kitchen area with island seating and a built-in banquette at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-b8e1-7429-8c48-a08cd432befd",
        "storage_key": "property/6767906449166301/01a01096-b8e1-7429-8c48-a08cd432befd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a stylish communal kitchen featuring ample counter space, comfortable seating, and modern appliances, perfect for gathering.",
      "link": "",
      "alt_text": "Modern communal kitchen area with island seating and a built-in banquette at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f3039547-8fee-4da8-bade-c5758420eccd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-dec8-75af-aeb5-8b3c43325f12.webp",
      "image_media": {
        "alt_text": "Modern lounge area with yellow sofas and chairs, view of pool area through large windows at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-dec8-75af-aeb5-8b3c43325f12",
        "storage_key": "property/6767906449166301/01a01096-dec8-75af-aeb5-8b3c43325f12.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating and scenic views of the pool and courtyard.",
      "link": "",
      "alt_text": "Modern lounge area with yellow sofas and chairs, view of pool area through large windows at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f88093bc-8886-4c13-b928-7408f61c04e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-d957-73d3-9ab7-f16bb2d6eae7.webp",
      "image_media": {
        "alt_text": "Billiard table in the resident lounge with seating and a bar area at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-d957-73d3-9ab7-f16bb2d6eae7",
        "storage_key": "property/6767906449166301/01a01096-d957-73d3-9ab7-f16bb2d6eae7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure time with friends and neighbors in our spacious resident lounge, featuring a billiard table, comfortable seating, and a fully equipped bar area.",
      "link": "",
      "alt_text": "Billiard table in the resident lounge with seating and a bar area at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6bd773ec-27b1-4697-9a4f-82b52cf39763",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-ebaa-75eb-a3d2-513ed3a84982.webp",
      "image_media": {
        "alt_text": "Conference room with a large table, chairs, and a printer.",
        "public_id": "01a01096-ebaa-75eb-a3d2-513ed3a84982",
        "storage_key": "property/6767906449166301/01a01096-ebaa-75eb-a3d2-513ed3a84982.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Meet and collaborate in our modern conference room, fully equipped for your business needs.",
      "link": "",
      "alt_text": "Conference room with a large table, chairs, and a printer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_44f50894-bbb4-47f2-9161-4006013d0834",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-c362-764a-8ce7-f8deb69992f7.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with seating and a TV, overlooking the pool.",
        "public_id": "01a01096-c362-764a-8ce7-f8deb69992f7",
        "storage_key": "property/6767906449166301/01a01096-c362-764a-8ce7-f8deb69992f7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable outdoor lounge, complete with plush seating and a large television. Step outside to enjoy the sparkling pool and resort-style amenities.",
      "link": "",
      "alt_text": "Outdoor lounge area with seating and a TV, overlooking the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c41713e2-6004-498e-b59b-625d4b5dd45b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-a9e2-76bd-a740-b7b73eda34ac.webp",
      "image_media": {
        "alt_text": "Ping pong table with paddles and balls in an outdoor covered patio area with a pool and lounge chairs in the background.",
        "public_id": "01a01096-a9e2-76bd-a740-b7b73eda34ac",
        "storage_key": "property/6767906449166301/01a01096-a9e2-76bd-a740-b7b73eda34ac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of ping pong on the outdoor table, located on a covered patio with easy access to the resort-style pool and lounge area.",
      "link": "",
      "alt_text": "Ping pong table with paddles and balls in an outdoor covered patio area with a pool and lounge chairs in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15bb8cf2-5434-4a14-8465-46ac5975d5b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-fca8-700e-b57e-0e377fcc44ba.webp",
      "image_media": {
        "alt_text": "Treadmills, stair climbers, weight machines, and a punching bag in a modern fitness center at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-fca8-700e-b57e-0e377fcc44ba",
        "storage_key": "property/6767906449166301/01a01096-fca8-700e-b57e-0e377fcc44ba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide array of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Treadmills, stair climbers, weight machines, and a punching bag in a modern fitness center at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b520e442-a214-45ba-8fcd-fba7be02fcd3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-f9dc-747c-a472-3994c26d1ad8.webp",
      "image_media": {
        "alt_text": "Gym with view of pool and apartment buildings at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-f9dc-747c-a472-3994c26d1ad8",
        "storage_key": "property/6767906449166301/01a01096-f9dc-747c-a472-3994c26d1ad8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with various equipment and a view of the resort-style pool area, perfect for residents to stay active and enjoy the outdoors.",
      "link": "",
      "alt_text": "Gym with view of pool and apartment buildings at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7f55acee-6bd8-412e-a5a5-e49c205fd6dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-6241-75bb-8ddf-ce7892d15d3b.webp",
      "image_media": {
        "alt_text": "Modern pet grooming station with a stainless steel tub, patterned tile, and a painting of a dog wearing a cowboy hat.",
        "public_id": "01a01096-6241-75bb-8ddf-ce7892d15d3b",
        "storage_key": "property/6767906449166301/01a01096-6241-75bb-8ddf-ce7892d15d3b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Pamper your furry friends at our state-of-the-art pet spa, complete with a grooming station for easy bathing and cleaning.",
      "link": "",
      "alt_text": "Modern pet grooming station with a stainless steel tub, patterned tile, and a painting of a dog wearing a cowboy hat.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_355db92e-f956-4798-b178-c7d9b8fdd812",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-5000-747c-88c8-27f59fbf847d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees in front of apartment buildings at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-5000-747c-88c8-27f59fbf847d",
        "storage_key": "property/6767906449166301/01a01096-5000-747c-88c8-27f59fbf847d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling outdoor swimming pool, surrounded by lush palm trees and comfortable lounge seating. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and palm trees in front of apartment buildings at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c816ea8a-7ebc-405d-b899-e3b3ab6aeb35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-2a08-7336-ad58-53620183e44d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with palm trees and lounge chairs at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-2a08-7336-ad58-53620183e44d",
        "storage_key": "property/6767906449166301/01a01096-2a08-7336-ad58-53620183e44d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling resort-style swimming pool, surrounded by lush palm trees and comfortable lounge chairs. Perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with palm trees and lounge chairs at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_21938ea1-3caf-4a38-8045-7b5be918038e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-8a33-77af-b993-93b9a16f5364.webp",
      "image_media": {
        "alt_text": "Outdoor covered lounge area with seating, TV, and grills next to a swimming pool.",
        "public_id": "01a01096-8a33-77af-b993-93b9a16f5364",
        "storage_key": "property/6767906449166301/01a01096-8a33-77af-b993-93b9a16f5364.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with a covered lounge featuring comfortable seating, a large TV, and multiple grills, all adjacent to a refreshing swimming pool.",
      "link": "",
      "alt_text": "Outdoor covered lounge area with seating, TV, and grills next to a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9cf09775-2ddf-43a9-9a0e-b5c1940fa633",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-5de0-74be-82ed-c5bd303d0a27.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with stainless steel grill, adjacent to a swimming pool and seating area at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-5de0-74be-82ed-c5bd303d0a27",
        "storage_key": "property/6767906449166301/01a01096-5de0-74be-82ed-c5bd303d0a27.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking at the community grilling station, conveniently located near the sparkling swimming pool and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor grilling station with stainless steel grill, adjacent to a swimming pool and seating area at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c7db592-925e-4ee3-ab4b-81fbb6a8fb96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-549b-75ea-a767-2d4278ae10ce.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with stainless steel grills and seating areas in a modern apartment complex courtyard at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-549b-75ea-a767-2d4278ae10ce",
        "storage_key": "property/6767906449166301/01a01096-549b-75ea-a767-2d4278ae10ce.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our state-of-the-art grilling stations, perfect for social gatherings and al fresco dining amidst beautifully landscaped courtyards.",
      "link": "",
      "alt_text": "Outdoor grilling area with stainless steel grills and seating areas in a modern apartment complex courtyard at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3437261a-dd6a-482b-a41e-7febad829a61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-3a66-77f2-88a6-66619fd92e55.webp",
      "image_media": {
        "alt_text": "Playground with slide and climbing wall in front of apartment buildings at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-3a66-77f2-88a6-66619fd92e55",
        "storage_key": "property/6767906449166301/01a01096-3a66-77f2-88a6-66619fd92e55.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring a slide and climbing wall, perfect for residents of all ages.",
      "link": "",
      "alt_text": "Playground with slide and climbing wall in front of apartment buildings at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_14b7cc60-8adc-4323-9288-5f4e30c2961a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-8475-735e-8eef-49691ff8dc17.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and island with bar stools.",
        "public_id": "01a01096-8475-735e-8eef-49691ff8dc17",
        "storage_key": "property/6767906449166301/01a01096-8475-735e-8eef-49691ff8dc17.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this spacious, modern kitchen featuring ample cabinet space, granite countertops, and a large island perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_86173a1a-6764-4997-925c-9d08cd2358ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-95f6-754f-aec7-0743ea3dfc67.webp",
      "image_media": {
        "alt_text": "Kitchen island with sink and living room in background.",
        "public_id": "01a01096-95f6-754f-aec7-0743ea3dfc67",
        "storage_key": "property/6767906449166301/01a01096-95f6-754f-aec7-0743ea3dfc67.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen island with granite countertops and a sink, opening to a well-lit living room with a sofa and coffee table.",
      "link": "",
      "alt_text": "Kitchen island with sink and living room in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7e79bb0f-5c9f-433e-bf7e-4598ce3b4dbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-35a0-7646-8104-e5d0aefb5414.webp",
      "image_media": {
        "alt_text": "Modern living room with a sofa, coffee table, TV, and abstract art at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-35a0-7646-8104-e5d0aefb5414",
        "storage_key": "property/6767906449166301/01a01096-35a0-7646-8104-e5d0aefb5414.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living space featuring a comfortable sofa, a unique wooden coffee table, and contemporary decor. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Modern living room with a sofa, coffee table, TV, and abstract art at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f572ae2a-925e-498d-99e6-ac91715e81f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-83a8-70ee-bb61-88ac22d840c6.webp",
      "image_media": {
        "alt_text": "A comfortable bedroom with a queen-size bed, white bedding, and green accent pillows.",
        "public_id": "01a01096-83a8-70ee-bb61-88ac22d840c6",
        "storage_key": "property/6767906449166301/01a01096-83a8-70ee-bb61-88ac22d840c6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant nightstands, and tasteful decor for a serene atmosphere.",
      "link": "",
      "alt_text": "A comfortable bedroom with a queen-size bed, white bedding, and green accent pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df20ad2e-21a4-4da5-94ed-2ab50535478e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-82c0-7432-9fa9-a48d6bdff61e.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop and sink, reflection shows bedroom at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-82c0-7432-9fa9-a48d6bdff61e",
        "storage_key": "property/6767906449166301/01a01096-82c0-7432-9fa9-a48d6bdff61e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "View the spacious bathroom vanity with ample counter space and a sink, leading into a comfortable bedroom.",
      "link": "",
      "alt_text": "Bathroom vanity with granite countertop and sink, reflection shows bedroom at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_48674693-feb9-4539-9cb0-85851109f949",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-8b2e-72be-9408-70bfcce1209e.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, modern furniture, and natural light at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-8b2e-72be-9408-70bfcce1209e",
        "storage_key": "property/6767906449166301/01a01096-8b2e-72be-9408-70bfcce1209e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-size bed, elegant decor, and ample natural light, creating a serene retreat.",
      "link": "",
      "alt_text": "Spacious bedroom with a king-size bed, modern furniture, and natural light at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3e87dd9-a413-4169-9940-532f05095784",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/01a01096-a4c0-7266-aa59-e916b261469b.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a table overlooking the community at Lumina Mountain Vista in Mesa, AZ,",
        "public_id": "01a01096-a4c0-7266-aa59-e916b261469b",
        "storage_key": "property/6767906449166301/01a01096-a4c0-7266-aa59-e916b261469b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony with seating, perfect for relaxing and enjoying the views.",
      "link": "",
      "alt_text": "Balcony with two chairs and a table overlooking the community at Lumina Mountain Vista in Mesa, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7cf04ba8-eee5-40a5-8678-3c04656c0053",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "1764 S Signal Butte Rd, Mesa, AZ 85209, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "People say this department store offers a wide variety of fashion, home goods, and food. They highlight the great deals and the well-organized layout. They also like the easy returns and helpful service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-5ed3-72aa-aa52-d7b9ad7129b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-5ed3-72aa-aa52-d7b9ad7129b1",
        "storage_key": "property/6767906449166301/019d02c7-5ed3-72aa-aa52-d7b9ad7129b1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8429658234793181219&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "33.3827535",
      "poi_longitude": "-111.6028181",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-354-7511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-071a005294f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-071a005294f5",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-071a005294f5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo5AFNqCxK4cRI0DLloAp_HQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_1159fa29-4aa7-426b-8ec1-4af55e3fc1e6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "1614 S Signal Butte Rd, Mesa, AZ 85209, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ3fM4VxSxK4cR2UN-atV-Izg/photos/ATCDNfUSWmMd6n_w1WTDM7lKrB9_8PR0yOcKKZ2NUBKFODAY92VQEYAQqLXCS4WPa_2K0aslQWRJ7bNPMP2o5cZmTG6q-PqVl-opKeSvpR16GzIT9JZoJjlIoBrJOPq6V46EdUrI_FwH6mb-CJZOpG5tvMASp1s1Ax40XGtwoor8dMZ7n38iOCrMndBROQ8FB3sT8k4S9Z1Zf19GNnCYfXHi7GM_IDBnhKQY_jve9XduxlLM0jFlMtmFLxXVO0qYs6UQzq5H4h0flG_bjv04Qec0rPi1pnErz_cZG3EDpo9QLw7H1g/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=720&maxHeightPx=405",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ulta.com/stores/mesa-az-225",
      "poi_directions_map_url": "https://maps.google.com/?cid=4045216345388631001&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "33.3848701",
      "poi_longitude": "-111.6015001",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-357-8181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-071a005294f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-071a005294f5",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-071a005294f5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3fM4VxSxK4cR2UN-atV-Izg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cosmetics_store"
    },
    {
      "id": "custom_8afdf4e5-8251-465e-998a-bf2175713064",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "6932 E Hampton Ave, Mesa, AZ 85209, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "People say this pet supply store offers wonderful grooming services, including nail painting. They also highlight the staff can be knowledgeable and helpful.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-5d05-70d8-a1f4-86f3d7ebc0f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-5d05-70d8-a1f4-86f3d7ebc0f8",
        "storage_key": "property/6767906449166301/019d02c7-5d05-70d8-a1f4-86f3d7ebc0f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/az/mesa-store0154.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=7529467505616054682&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "33.3921799",
      "poi_longitude": "-111.6816074",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-830-7282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-071a005294f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-071a005294f5",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-071a005294f5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8aCfiw-xK4cRmmkXtM0Kfmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_b9c54f59-aedc-4ff8-842d-2df692d1a6ff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6131 E Southern Ave, Mesa, AZ 85206, USA",
      "poi_short_description": "Department store stocking electronics, toys, clothing and groceries, plus a pharmacy.",
      "poi_long_description": "Shoppers say this department store offers fair prices, a wide variety of products, and a convenient pick-up service. They also highlight the friendly and helpful staff, and the clean and well-stocked environment.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-5dcf-724b-9373-6712abcf8f4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-5dcf-724b-9373-6712abcf8f4b",
        "storage_key": "property/6767906449166301/019d02c7-5dcf-724b-9373-6712abcf8f4b.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1646-mesa-az/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10188226108001980380&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.3914993",
      "poi_longitude": "-111.6990678",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-830-3919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-071a005294f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-071a005294f5",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-071a005294f5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa8yxWbCvK4cR3I_RaqrZY40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_0b197a6f-eb82-484a-a642-c9ff1a6256df",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Rusty Buckle Saloon",
      "poi_type": "Restaurants",
      "poi_address": "285 N Apache Trail, Apache Junction, AZ 85120, USA",
      "poi_short_description": "Relaxed eatery (formerly a steak house) serving burgers and fried eats alongside craft cocktails.",
      "poi_long_description": "Diners say this restaurant serves up delicious prime rib sliders, chicken fried steak, fish and chips, and apple pie. They also highlight the friendly and attentive service, fun atmosphere with live music, and reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-6452-738f-88a5-185375cde803.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-6452-738f-88a5-185375cde803",
        "storage_key": "property/6767906449166301/019d02c7-6452-738f-88a5-185375cde803.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://rustybucklesaloon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2174821268895679627&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rusty-buckle-saloon",
      "poi_latitude": "33.4174814",
      "poi_longitude": "-111.5469768",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-625-1386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-020f1737be2b",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd-j85Ve3K4cRi8R93muELh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bae1cf74-e355-465f-afae-409c705d0a18",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Native Grill & Wings",
      "poi_type": "Restaurants",
      "poi_address": "1947 S Signal Butte Rd, Mesa, AZ 85209, USA",
      "poi_short_description": "Sports-bar chain offering an extensive pub menu starring Buffalo chicken wings.",
      "poi_long_description": "People say this chicken wings restaurant serves delicious wings, pizza, and unbreaded chicken strips. They also highlight the excellent selection of draft beers, the attentive service, and the relaxed dining area.\n\nOther reviews mention the boneless wings can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-6318-747f-a415-13a6b0f74136.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-6318-747f-a415-13a6b0f74136",
        "storage_key": "property/6767906449166301/019d02c7-6318-747f-a415-13a6b0f74136.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.nativegrillandwings.com/ll/US/AZ/Mesa/1947-S_-Signal-Butte*-Suite-A",
      "poi_directions_map_url": "https://maps.google.com/?cid=3538975122897898601&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "native-grill--wings",
      "poi_latitude": "33.379495",
      "poi_longitude": "-111.598995",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-380-1190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-020f1737be2b",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-d-sDGuxK4cRaQxGvR_3HDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_d9eabb7a-443e-4c5a-9312-e60ed946b38e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "AMC Mesa Grand 14",
      "poi_type": "Entertainment",
      "poi_address": "1645 S Stapley Dr, Mesa, AZ 85204, USA",
      "poi_short_description": "Chain movie theater featuring IMAX, Dolby Cinema, and plush, reclining seats.",
      "poi_long_description": "Moviegoers say this movie theater offers comfortable reclining seats, a great Dolby Digital experience, and a wide selection of snacks, including popcorn. They also highlight the friendly and helpful staff, the clean facilities, and the convenient features like free refills and online ordering.\n\nSome reviews mention the concession prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-640e-7474-8065-adde2ce35c41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-640e-7474-8065-adde2ce35c41",
        "storage_key": "property/6767906449166301/019d02c7-640e-7474-8065-adde2ce35c41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/phoenix/amc-mesa-grand-14?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11496104796945459597&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-mesa-grand-14",
      "poi_latitude": "33.384176",
      "poi_longitude": "-111.8020733",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-503-1680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-7c64-749d-a0d7-5b8fef6a24f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-7c64-749d-a0d7-5b8fef6a24f3",
        "storage_key": "property/6767906449166301/019d02c7-7c64-749d-a0d7-5b8fef6a24f3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJlaU0nfOoK4cRjSmZYmdeip8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_412c7edc-5e88-42c6-9d81-a206dd87ffc7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Signal Butte Park",
      "poi_type": "Entertainment",
      "poi_address": "11132 E Elliot Rd, Mesa, AZ 85212, USA",
      "poi_short_description": "Shade-covered park boasting a water feature with a splash zone and multiple play structures.",
      "poi_long_description": "Visitors say this park offers a unique playground with a spaceship theme, a splash pad, and a walking path. They also highlight that the park is inclusive, with features like a dog water fountain and shaded seating, making it a great spot for families, dog owners, and those seeking exercise.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-684f-7209-b773-b8cab8f70829.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-684f-7209-b773-b8cab8f70829",
        "storage_key": "property/6767906449166301/019d02c7-684f-7209-b773-b8cab8f70829.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mesaaz.gov/Activities-Culture/Parks-Recreation-and-Community-Facilities/Parks-Facilities/Signal-Butte-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9853226601971015867&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "signal-butte-park",
      "poi_latitude": "33.350861",
      "poi_longitude": "-111.5939638",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-644-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7fda-77bc-94e8-90c519f3ace0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7fda-77bc-94e8-90c519f3ace0",
        "storage_key": "property/6767906449166301/019d02c5-7fda-77bc-94e8-90c519f3ace0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdeW-fnSzK4cRu2DpzWOxvYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_63d1384e-b279-4e99-8029-ad424b944dca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Skateland",
      "poi_type": "Entertainment",
      "poi_address": "7 E Southern Ave, Mesa, AZ 85210, USA",
      "poi_short_description": "High-energy spot for roller skaters ages 5 & up, with a snack bar, arcade, special events & more.",
      "poi_long_description": "People say this roller skating rink offers a fun, retro vibe with great music and lights, and is a popular spot for birthday parties. They also highlight the friendly staff, clean rink, and well-maintained skates.\n\nOther reviews mention the food options can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-682c-762b-918e-6df023b68dfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-682c-762b-918e-6df023b68dfb",
        "storage_key": "property/6767906449166301/019d02c7-682c-762b-918e-6df023b68dfb.webp",
        "width": 1179,
        "height": 638
      },
      "poi_business_url": "https://www.unitedskates.com/skateland-mesa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10039581733811081639&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "skateland",
      "poi_latitude": "33.392564",
      "poi_longitude": "-111.830821",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-833-7775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVo3eXKoK4cRp1FPGWXCU4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_c8d4ab4e-519a-4ee9-9d36-0455f9a1e445",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Lucky Strikes",
      "poi_type": "Entertainment",
      "poi_address": "1985 Apache Trail, Apache Junction, AZ 85120, USA",
      "poi_short_description": "Spartan, unpretentious bar & grill with pool tables, plus frequent live music & karaoke nights.",
      "poi_long_description": "Spartan, unpretentious bar & grill with pool tables, plus frequent live music & karaoke nights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-6a51-756e-8820-550a5ac6f6d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-6a51-756e-8820-550a5ac6f6d9",
        "storage_key": "property/6767906449166301/019d02c7-6a51-756e-8820-550a5ac6f6d9.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://m.facebook.com/LuckyStrikesAZ/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15194813310876851819&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lucky-strikes",
      "poi_latitude": "33.4146234",
      "poi_longitude": "-111.5675827",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-982-0753",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-7e26-765f-bf49-1027de7acd24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-7e26-765f-bf49-1027de7acd24",
        "storage_key": "property/6767906449166301/019d02c7-7e26-765f-bf49-1027de7acd24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf55KfCy3K4cRax4xXzPS3tI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_9dd654fd-8dcd-4d1b-aaa7-c0203a615965",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Jake's Unlimited",
      "poi_type": "Entertainment",
      "poi_address": "1830 E Baseline Rd, Mesa, AZ 85204, USA",
      "poi_short_description": "Center for kids of all ages to enjoy bowling, laser tag & other games plus a massive smorgasbord.",
      "poi_long_description": "Visitors say this video arcade offers a wide variety of entertainment options, including laser tag, bumper cars, bowling, and a buffet with pizza, pasta, and salad. They like that it's a great place for families with kids of all ages to have fun, and that the price is reasonable for an all-day play and buffet package.\n\nSome reviews mention the arcade games can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-6935-701e-825d-b25a40dee265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-6935-701e-825d-b25a40dee265",
        "storage_key": "property/6767906449166301/019d02c7-6935-701e-825d-b25a40dee265.webp",
        "width": 1200,
        "height": 798
      },
      "poi_business_url": "https://www.jakesunlimited.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12657065507782177647&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jakes-unlimited",
      "poi_latitude": "33.3799003",
      "poi_longitude": "-111.790972",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-926-7499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHV0cUO-oK4cRb7M08gTupq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "video_arcade"
    },
    {
      "id": "custom_bf156471-1cba-4115-a6df-a0b249bd4e12",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Skyline Aquatic Center",
      "poi_type": "Entertainment",
      "poi_address": "845 S Crismon Rd, Mesa, AZ 85208, USA",
      "poi_short_description": "Outdoor city aquatics center featuring an Olympic-size competition pool, water slide & shaded seats.",
      "poi_long_description": "People say this swimming facility offers a large pool, slides, diving boards, and a zero-depth entry area. They highlight the affordable prices, ample shaded seating, and the ability to bring in outside food. They also like the attentive staff and the spacious layout, especially for competitions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-6cc2-726b-b9b4-e8ee360817dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-6cc2-726b-b9b4-e8ee360817dc",
        "storage_key": "property/6767906449166301/019d02c7-6cc2-726b-b9b4-e8ee360817dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mesaaz.gov/Activities-Culture/Parks-Recreation-and-Community-Facilities/Pools-and-Aquatics/Skyline",
      "poi_directions_map_url": "https://maps.google.com/?cid=4209270183706970315&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "skyline-aquatic-center",
      "poi_latitude": "33.396782",
      "poi_longitude": "-111.614",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-644-6040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITMAFAGxK4cRy0h_L-5Uajo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_923243f5-2657-4a78-a898-deac8aa36c10",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Superstition Springs Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "6555 E Southern Ave, Mesa, AZ 85206, USA",
      "poi_short_description": "Mall featuring a two-story carousel and a food court alongside a variety of familiar retailers.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and great deals. They also highlight the clean and nostalgic atmosphere, and the easy access and parking.\n\nOther reviews mention some stores can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-6d7f-704b-bd2b-f86d25997367.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-6d7f-704b-bd2b-f86d25997367",
        "storage_key": "property/6767906449166301/019d02c7-6d7f-704b-bd2b-f86d25997367.webp",
        "width": 640,
        "height": 1280
      },
      "poi_business_url": "https://www.superstitionsprings.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=9098130514455570276&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "superstition-springs-center",
      "poi_latitude": "33.3902535",
      "poi_longitude": "-111.6902089",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-832-0212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-071a005294f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-071a005294f5",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-071a005294f5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0ZPM-7WvK4cRZCdEun8NQ34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c27533c4-4af8-409a-ab3f-dca4cb6649a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Fry's Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "2724 S Signal Butte Rd, Mesa, AZ 85209, USA",
      "poi_short_description": "Outpost of a grocery store chain with typical offerings like produce, meat & household supplies.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, and deli items, as well as a good selection of international and organic products. They highlight the store's clean and well-stocked shelves, and the convenient parking and gas station. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-3bf1-7740-b6cd-98529a4be349.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-3bf1-7740-b6cd-98529a4be349",
        "storage_key": "property/6767906449166301/019d02c5-3bf1-7740-b6cd-98529a4be349.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.frysfood.com/stores/grocery/az/mesa/signal-butte-rd-guadalupe/660/00686?cid=loc_66000686_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15904674661995598943&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "frys-marketplace",
      "poi_latitude": "33.3658403",
      "poi_longitude": "-111.6039974",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-481-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-795b-7038-80c3-88c2629f319c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-795b-7038-80c3-88c2629f319c",
        "storage_key": "property/6767906449166301/019d02c5-795b-7038-80c3-88c2629f319c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdc5pD2SxK4cRX1RnqFbBuNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4ca62935-cea6-481e-a352-8cc8d9607994",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Babbo Italian Eatery",
      "poi_type": "Restaurants",
      "poi_address": "10726 E Southern Ave, Mesa, AZ 85209, USA",
      "poi_short_description": "Relaxed local restaurant & bar chain serving Italian fare & cocktails in a contemporary atmosphere.",
      "poi_long_description": "People say this Italian restaurant serves delicious spaghetti and meatballs, and stuffed Portobello mushrooms. They also highlight the friendly and attentive service, and the cozy, casual vibe.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-6ff5-7196-8e29-1d0b3023551a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-6ff5-7196-8e29-1d0b3023551a",
        "storage_key": "property/6767906449166301/019d02c7-6ff5-7196-8e29-1d0b3023551a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.babboitalian.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3852817002161095486&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "babbo-italian-eatery",
      "poi_latitude": "33.3938518",
      "poi_longitude": "-111.5994179",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-354-2322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-020f1737be2b",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnUgyXwexK4cRPsNlfqb0dzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_1c275cc5-824d-4581-801c-5aad23f2b1d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "First Watch Mountain Vista",
      "poi_type": "Restaurants",
      "poi_address": "1534 S Signal Butte Rd Ste 105, Mesa, AZ 85209, USA",
      "poi_short_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_long_description": "People say this breakfast restaurant offers fresh, healthy, and flavorful breakfast and brunch options, including a delicious chickichanga and shrimp and grits. They highlight the reasonable prices, large portions, and convenient location with outdoor seating. They also like the friendly and attentive service, and the bright, welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-6fea-739f-9069-aad3aa1b47c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-6fea-739f-9069-aad3aa1b47c9",
        "storage_key": "property/6767906449166301/019d02c7-6fea-739f-9069-aad3aa1b47c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.firstwatch.com/locations/mountain-vista/?utm_source=gbp-listing&utm_medium=organic&utm_campaign=gbp-listing&utm_content=mountain-vista",
      "poi_directions_map_url": "https://maps.google.com/?cid=2478893459113705980&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "first-watch-mountain-vista",
      "poi_latitude": "33.3886963",
      "poi_longitude": "-111.5986124",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-524-2117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-020f1737be2b",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzNWVD6xK4cR_AGDonfMZiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_e294366e-300e-46be-9536-def23ff33d71",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Dirtwater Springs",
      "poi_type": "Restaurants",
      "poi_address": "586 Apache Trail, Apache Junction, AZ 85120, USA",
      "poi_short_description": "Down-home shack turning out unfussy American eats, plus Mexican plates & a weekly fish fry.",
      "poi_long_description": "People say this family restaurant serves delicious burgers, fried chicken, and fish and chips. They also highlight the fun, rustic atmosphere with Western decor and the friendly, attentive service.\n\nSome reviews mention there can be long wait times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-7270-7628-945c-516265dab21f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-7270-7628-945c-516265dab21f",
        "storage_key": "property/6767906449166301/019d02c7-7270-7628-945c-516265dab21f.webp",
        "width": 1280,
        "height": 840
      },
      "poi_business_url": "http://www.dirtwatersprings.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6876646479044925577&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dirtwater-springs",
      "poi_latitude": "33.4154114",
      "poi_longitude": "-111.5523658",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-983-3478",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-020f1737be2b",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_bUNSG3K4cRidhp5YnBbl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "custom_e36ddb5f-78e9-4903-add8-c92ff6571184",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Red Mountain Branch - Mesa Public Library",
      "poi_type": "Education",
      "poi_address": "635 N Power Rd, Mesa, AZ 85205, USA",
      "poi_short_description": "Cozy library with a selection of books, from fiction to mystery, as well as CDs, DVDs and audiobooks.",
      "poi_long_description": "Visitors say this public library offers a calm and inviting atmosphere, with a wide selection of books, DVDs, and audiobooks, as well as a \"stuff-brary\" where you can check out items like tools and kitchenware. They also highlight the friendly, helpful, and knowledgeable staff who go out of their way to assist patrons.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-3c95-777c-a165-cb1f834e13f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-3c95-777c-a165-cb1f834e13f7",
        "storage_key": "property/6767906449166301/019d02c5-3c95-777c-a165-cb1f834e13f7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mesalibrary.org/about/hours-and-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=10682650412271200103&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "red-mountain-branch---mesa-public-library",
      "poi_latitude": "33.4275277",
      "poi_longitude": "-111.6836568",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 480-644-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab",
        "storage_key": "property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi5uvLvSvK4cRZ-caa_NlQJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_faca980f-e097-464f-9f82-a244bc927178",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Mesa Community College - Red Mountain Campus",
      "poi_type": "Education",
      "poi_address": "7110 E McKellips Rd, Mesa, AZ 85207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-3d04-760c-83e6-55fb3ea631e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-3d04-760c-83e6-55fb3ea631e5",
        "storage_key": "property/6767906449166301/019d02c5-3d04-760c-83e6-55fb3ea631e5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mesacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4214144016360701860&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mesa-community-college---red-mountain-campus",
      "poi_latitude": "33.4552619",
      "poi_longitude": "-111.67854",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-654-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab",
        "storage_key": "property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa45LLDilK4cRpH-Ex6elezo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d625f839-2287-4e60-9751-79cd0c1e8fec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1558 S Signal Butte Rd, Mesa, AZ 85209, USA",
      "poi_short_description": "High-value, low-price chain gym featuring a pool, saunas, and massage chairs, plus group classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including treadmills, free weights, and weight machines, as well as amenities like a sauna, pool, and massage chairs. They also highlight the friendly and helpful staff, and the clean and spacious facilities.\n\nOther reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-4de4-762a-b105-625a0df5ba58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-4de4-762a-b105-625a0df5ba58",
        "storage_key": "property/6767906449166301/019d02c5-4de4-762a-b105-625a0df5ba58.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/mesa-signal-butte-rd-hwy-60/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12526140321475105407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.388061",
      "poi_longitude": "-111.5996167",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 480-672-2880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-bL_56xK4cRf5I4jEHK1a0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_86cb56df-5259-47f3-bd40-ebae79532d3c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "US Nails & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "10633 E Apache Trail #108, Apache Junction, AZ 85120, USA",
      "poi_short_description": "Salon offering manicures and pedicures, plus waxes, massages and other services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-4ef2-71b8-a10d-b0b6a282dd83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-4ef2-71b8-a10d-b0b6a282dd83",
        "storage_key": "property/6767906449166301/019d02c5-4ef2-71b8-a10d-b0b6a282dd83.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15428627768172460810&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "us-nails--spa",
      "poi_latitude": "33.4136132",
      "poi_longitude": "-111.6010372",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-354-1144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Zmj-OWwK4cRCrul9TV_HdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_7e975acf-444a-42f5-8c38-b8e5c491bbaf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3003 W Apache Trail Ste 1, Apache Junction, AZ 85120, USA",
      "poi_short_description": "Chain gym featuring cardio equipment and weights, plus hydro-massage beds for relaxation.",
      "poi_long_description": "People say this fitness center offers a wide variety of exercise equipment and machines. They highlight the clean facilities, ample parking, and convenient 24-hour access. They also like the friendly and helpful staff, and the availability of personal training sessions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-57f0-740d-8f71-167f413359c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-57f0-740d-8f71-167f413359c3",
        "storage_key": "property/6767906449166301/019d02c5-57f0-740d-8f71-167f413359c3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/apache-junction-az?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11557674042288160896&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.4136933",
      "poi_longitude": "-111.5786091",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-845-1021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_TTJFNGwK4cRgMBWaE4bZaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3ec30850-9aad-4b39-9545-915b4a5f1319",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1905 S Signal Butte Rd, Mesa, AZ 85209, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including weights, cardio machines, a pool, and basketball courts, and is clean and well-maintained.\n\nOther reviews mention the saunas and showers can be faulty and the front desk staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-588f-752e-b57c-c822884d8c13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-588f-752e-b57c-c822884d8c13",
        "storage_key": "property/6767906449166301/019d02c5-588f-752e-b57c-c822884d8c13.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=317&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3181933715326060210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.3808145",
      "poi_longitude": "-111.5988168",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-984-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQeCYcmuxK4cRskbZANt_KCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_95a8416b-3f05-4a39-93ad-e9961c58d453",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Banner Baywood Medical Center | Mesa, AZ | Baywood Ave.",
      "poi_type": "Health and Wellness",
      "poi_address": "6644 E Baywood Ave, Mesa, AZ 85206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-5b85-75f7-82bf-5afc46479c1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-5b85-75f7-82bf-5afc46479c1c",
        "storage_key": "property/6767906449166301/019d02c5-5b85-75f7-82bf-5afc46479c1c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/mesa/banner-baywood-medical-center?y_source=1_MTE5MDczNjYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15610473978386755787&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-baywood-medical-center--mesa-az--baywood-ave",
      "poi_latitude": "33.4109912",
      "poi_longitude": "-111.6880186",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-321-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7de3-7607-a774-6e7a403a70d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7de3-7607-a774-6e7a403a70d2",
        "storage_key": "property/6767906449166301/019d02c5-7de3-7607-a774-6e7a403a70d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQ64HuuvK4cRy7A4IWCLo9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_78d05195-e015-4fd5-9512-f0a4fc4ab350",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "HonorHealth Four Peaks Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 S Crismon Rd, Mesa, AZ 85209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-5c69-706a-a9d1-ef0286df28bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-5c69-706a-a9d1-ef0286df28bd",
        "storage_key": "property/6767906449166301/019d02c5-5c69-706a-a9d1-ef0286df28bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.honorhealth.com/locations/hospitals/mountin-vista-medical-center?utm_source=yext&utm_medium=local&utm_campaign=medicalcenter_mountainvista",
      "poi_directions_map_url": "https://maps.google.com/?cid=1462059852601866202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "honorhealth-four-peaks-medical-center",
      "poi_latitude": "33.3916668",
      "poi_longitude": "-111.6110973",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 480-358-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7de3-7607-a774-6e7a403a70d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7de3-7607-a774-6e7a403a70d2",
        "storage_key": "property/6767906449166301/019d02c5-7de3-7607-a774-6e7a403a70d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJETgF7AWxK4cR2rexirBHShQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3299d575-fd3e-464a-86a2-f6eafd5e4e3f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Superstition Springs Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6542 E Baseline Rd, Mesa, AZ 85206, USA",
      "poi_short_description": "Golf club with a championship course, dining options, and event space.",
      "poi_long_description": "People say this public golf course offers a challenging layout with some standout holes, and the staff is friendly and helpful.\n\nOther reviews mention the pace of play can be slow and the tee boxes can be uneven.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-6412-751f-9a98-be8837193f59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-6412-751f-9a98-be8837193f59",
        "storage_key": "property/6767906449166301/019d02c5-6412-751f-9a98-be8837193f59.webp",
        "width": 1280,
        "height": 1046
      },
      "poi_business_url": "https://superstitionspringsgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10392492965785347465&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "superstition-springs-golf-club",
      "poi_latitude": "33.3801378",
      "poi_longitude": "-111.6924828",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-985-5622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-83a4-700a-b8ff-e07e7c83e6e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-83a4-700a-b8ff-e07e7c83e6e4",
        "storage_key": "property/6767906449166301/019d02c5-83a4-700a-b8ff-e07e7c83e6e4.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UiZnEmuK4cRiaVhZEqNOZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_902e5890-c7e7-43a2-8fb2-fe1fb04a41d4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Augusta Ranch Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2401 S Lansing, Mesa, AZ 85209, USA",
      "poi_short_description": "Par-61 layout featuring golf carts, a restaurant and a driving range, plus friendly staff.",
      "poi_long_description": "People say this golf course offers a well-maintained executive course, a driving range with TopTracer technology, and a practice area for putting and chipping. They highlight the reasonable rates, especially for youth, and the fun, family-friendly atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-6723-72f0-9950-cc58ebb403ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-6723-72f0-9950-cc58ebb403ab",
        "storage_key": "property/6767906449166301/019d02c5-6723-72f0-9950-cc58ebb403ab.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.augustaranchgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4871679072886687231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "augusta-ranch-golf-club",
      "poi_latitude": "33.3718656",
      "poi_longitude": "-111.6314223",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-354-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-83a4-700a-b8ff-e07e7c83e6e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-83a4-700a-b8ff-e07e7c83e6e4",
        "storage_key": "property/6767906449166301/019d02c5-83a4-700a-b8ff-e07e7c83e6e4.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaCDFZexK4cR_4UdN06um0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ddebbf60-cf33-4eca-8c90-471e313c287a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "NTT PH1 Datacenter",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10256 E Elliot Rd, Mesa, AZ 85212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-6c86-763b-a604-e1a0c8005923.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-6c86-763b-a604-e1a0c8005923",
        "storage_key": "property/6767906449166301/019d02c5-6c86-763b-a604-e1a0c8005923.webp",
        "width": 911,
        "height": 1280
      },
      "poi_business_url": "https://services.global.ntt/en-us/services-and-products/global-data-centers/global-locations/americas/phoenix-ph1-data-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11836254396076620868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ntt-ph1-datacenter",
      "poi_latitude": "33.3552956",
      "poi_longitude": "-111.6141981",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-286-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxZ9fASmzK4cRRHxNfanSQqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c162b0e9-dfde-4550-9f27-3400e94d2c60",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "SilverRock Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7465 E Hampton Ave, Mesa, AZ 85209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-6e61-744b-94dd-00ca55ee9a45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-6e61-744b-94dd-00ca55ee9a45",
        "storage_key": "property/6767906449166301/019d02c5-6e61-744b-94dd-00ca55ee9a45.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://silverrockinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13578507014664627469&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "silverrock-inc",
      "poi_latitude": "33.3886718",
      "poi_longitude": "-111.6710357",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 877-864-4790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqynvZyuuK4cRDSU8FTCMcLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f6af3b08-73bf-44ab-9454-976496fa6f7c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Apache Junction City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 E Superstition Blvd, Apache Junction, AZ 85119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-6e6f-72ea-bfde-ff55f3cdaeae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-6e6f-72ea-bfde-ff55f3cdaeae",
        "storage_key": "property/6767906449166301/019d02c5-6e6f-72ea-bfde-ff55f3cdaeae.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://www.ajcity.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11012833505415913879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "apache-junction-city-hall",
      "poi_latitude": "33.4236317",
      "poi_longitude": "-111.5430572",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-982-8002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-84a6-753b-b847-7446ad868f41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-84a6-753b-b847-7446ad868f41",
        "storage_key": "property/6767906449166301/019d02c5-84a6-753b-b847-7446ad868f41.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDwTX2xm3K4cRl-HVhLlx1Zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_c872ffa7-274c-42d6-b272-4d9df8f49d68",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Apache Junction Rock and Gem Club",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2151 W Superstition Blvd, Apache Junction, AZ 85120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7183-714d-90f9-db141a18e625.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c5-7183-714d-90f9-db141a18e625",
        "storage_key": "property/6767906449166301/019d02c5-7183-714d-90f9-db141a18e625.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ajrockclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15336584998915586798&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "apache-junction-rock-and-gem-club",
      "poi_latitude": "33.4220331",
      "poi_longitude": "-111.5694884",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 941-735-5136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbwcUJDO3K4cR7rryv8x-1tQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0e28e9fa-db9a-477e-8a37-8599080084ca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Sol Azteca Mexican Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "9265 E Baseline Rd #103, Mesa, AZ 85209, USA",
      "poi_short_description": "Easygoing eatery serving an array of everyday Mexican standards like tacos & seafood burritos.",
      "poi_long_description": "Diners like this restaurant's authentic Mexican food, highlighting dishes like the Azteca burrito, molcajetito, and creamy refried beans, along with a fresh salsa bar and delicious horchata. They also mention the generous portions and reasonable prices, especially for lunch specials. Guests appreciate the friendly, attentive staff and the clean, welcoming atmosphere, noting fast service even when busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019eb2e1-a137-749a-abf6-9a626615edee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e1-a137-749a-abf6-9a626615edee",
        "storage_key": "property/6767906449166301/019eb2e1-a137-749a-abf6-9a626615edee.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.solaztecamk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5398653346153064929&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sol-azteca-mexican-kitchen",
      "poi_latitude": "33.3787611",
      "poi_longitude": "-111.6330014",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-656-9060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-020f1737be2b",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Xs0_7yxK4cR4Wntcp3e60o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_c008e922-1af9-4d86-89f1-4836cd705ddd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Barro's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "10861 E Baseline Rd, Mesa, AZ 85209, USA",
      "poi_short_description": "Regional chain serving thick- & thin-crust pies, wings & sandwiches in a simple setting.",
      "poi_long_description": "Diners say this restaurant offers delicious pizza, wings, and large salads, with many highlighting the great lunch specials and consistent quality. They also mention the friendly staff, clean restaurant, and comfortable, relaxed vibe.\n\nSome reviews mention there can be long wait times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c7-5de1-72ae-b228-5732156144a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-5de1-72ae-b228-5732156144a3",
        "storage_key": "property/6767906449166301/019d02c7-5de1-72ae-b228-5732156144a3.webp",
        "width": 1280,
        "height": 835
      },
      "poi_business_url": "https://barrospizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4117879093875797452&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barros-pizza",
      "poi_latitude": "33.3783631",
      "poi_longitude": "-111.5993529",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-357-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-78db-7588-9bdb-020f1737be2b",
        "storage_key": "property/6767906449166301/019d02c5-78db-7588-9bdb-020f1737be2b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3euarBmxK4cRzG156jelJTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_f914decc-38d9-484e-8065-7b40f67cb087",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Amazon Fulfillment Center - QZZ7",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8560 E Elliot Rd, Mesa, AZ 85212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fc-f0da-701a-a260-7da756b4518e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-f0da-701a-a260-7da756b4518e",
        "storage_key": "property/6767906449166301/019f14fc-f0da-701a-a260-7da756b4518e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amazon.jobs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17316314876075652834&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amazon-fulfillment-center---qzz7",
      "poi_latitude": "33.3511474",
      "poi_longitude": "-111.6529496",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqzVmdgOxK4cR4jZNT6LoT_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_a027dc67-e6a1-4b93-82bb-87e8663c350b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "The Boeing Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5000 E McDowell Rd, Mesa, AZ 85215, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fc-f592-71e8-8101-2ee02da65f4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-f592-71e8-8101-2ee02da65f4b",
        "storage_key": "property/6767906449166301/019f14fc-f592-71e8-8101-2ee02da65f4b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boeing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15131330919155889974&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-boeing-company",
      "poi_latitude": "33.4710189",
      "poi_longitude": "-111.7191463",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-891-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7dad-735b-9bc3-3a75b8c05465",
        "storage_key": "property/6767906449166301/019d02c5-7dad-735b-9bc3-3a75b8c05465.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCeuKM06kK4cRNvcrP01J_dE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_24e3f8b0-b254-4a3e-afbe-aafe6afaa2f5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Mesa Gateway Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6033 S Sossaman Rd, Mesa, AZ 85212, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors say this airport is clean, easy to navigate, and offers efficient security, making for a stress-free travel experience. They also highlight the friendly staff and convenient parking options, including a cell phone lot.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fc-f863-76a9-9deb-172c4b03e6a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-f863-76a9-9deb-172c4b03e6a5",
        "storage_key": "property/6767906449166301/019f14fc-f863-76a9-9deb-172c4b03e6a5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.gatewayairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11873809920753535279&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mesa-gateway-airport",
      "poi_latitude": "33.3089787",
      "poi_longitude": "-111.6559353",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-988-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fd-033e-759b-9fee-6f4dceb720dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-033e-759b-9fee-6f4dceb720dd",
        "storage_key": "property/6767906449166301/019f14fd-033e-759b-9fee-6f4dceb720dd.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJz1BeVICtK4cRLwkGeTY_yKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_4a2d3ab4-8076-4765-bcfc-3eb76454361d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Light Rail Station - Gilbert & Main",
      "poi_type": "Transportation & Transit",
      "poi_address": "Main St & Gilbert Rd, Mesa, AZ 85204",
      "poi_short_description": "Eastern terminus of the Valley Metro A Line with park-and-ride facilities",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_16631efe-8e88-4e6d-84ee-df07654c0737",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Valley Metro Bus Stop - Routes East-West",
      "poi_type": "Transportation & Transit",
      "poi_address": "E Southern Ave & S Higley Rd, Mesa, AZ 85206",
      "poi_short_description": "Valley Metro bus stop serving local east-west routes",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_76b70b4a-1eb3-4031-80f3-282f02f1cbfe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Valley Metro Bus Stop - Power & Southern",
      "poi_type": "Transportation & Transit",
      "poi_address": "Power Rd & Southern Ave, Mesa, AZ 85206",
      "poi_short_description": "Nearby Valley Metro bus stop with connections along Power Road",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_82014f31-d160-4d6f-803a-e9537e1ca193",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Valley Metro Bus Stop - Southern & Superstition Springs",
      "poi_type": "Transportation & Transit",
      "poi_address": "Southern Ave & Superstition Springs Blvd, Mesa, AZ 85206",
      "poi_short_description": "Valley Metro bus station serving local routes",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a7f1488b-8c4e-44c9-8ece-35601c0d0cc1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Valley Metro Light Rail",
      "poi_type": "Transportation & Transit",
      "poi_address": "6745 E Superstition Springs Blvd, Mesa, AZ 85206",
      "poi_short_description": "Valley Metro transit service providing connections to Mesa, Tempe, Phoenix, and Phoenix Sky Harbor Airport via the A Line.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_61ed4f2e-4680-4d55-82b8-66cd09e6f6c1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Desert Trails Bike Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2955 N Recker Rd, Mesa, AZ 85215, USA",
      "poi_short_description": "Sizable, 35-acre bike park with scenic views, a series of rugged biking trails & some big jumps.",
      "poi_long_description": "Visitors say this bike park offers a variety of trails for all skill levels, from beginners to experienced riders, with well-maintained trails and fun jump tracks. They also highlight the beautiful Arizona sunsets, the opportunity to see wildlife, and the friendly atmosphere with hikers and bikers sharing the trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fc-f52e-7175-a373-c75e11405e95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-f52e-7175-a373-c75e11405e95",
        "storage_key": "property/6767906449166301/019f14fc-f52e-7175-a373-c75e11405e95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mesaparks.com/parks-facilities/parks/desert-trails-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14684800806917809455&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "desert-trails-bike-park",
      "poi_latitude": "33.4693014",
      "poi_longitude": "-111.7001029",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-644-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7fda-77bc-94e8-90c519f3ace0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7fda-77bc-94e8-90c519f3ace0",
        "storage_key": "property/6767906449166301/019d02c5-7fda-77bc-94e8-90c519f3ace0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ3nTx2lK4cRL6W0zYfkyss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_419f668f-f2de-467d-a008-442d6da5b01e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Monterey Park - Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7045 E Monterey Ave, Mesa, AZ 85209, USA",
      "poi_short_description": "Relaxed local space featuring a playground, a baseball field and a fenced dog area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fc-f157-710c-bd7e-b6e802534da5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-f157-710c-bd7e-b6e802534da5",
        "storage_key": "property/6767906449166301/019f14fc-f157-710c-bd7e-b6e802534da5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mesaparks.com/parks-facilities/parks/monterey-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13046528296756320715&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "monterey-park---playground",
      "poi_latitude": "33.3668164",
      "poi_longitude": "-111.6822587",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-644-2352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7fda-77bc-94e8-90c519f3ace0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7fda-77bc-94e8-90c519f3ace0",
        "storage_key": "property/6767906449166301/019d02c5-7fda-77bc-94e8-90c519f3ace0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYUlwij2uK4cRyxk-yFyUDrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2598b11f-4d63-4c09-be8b-116fe9b4abc5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Skyline Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "655 S Crismon Rd, Mesa, AZ 85208, USA",
      "poi_short_description": "This 30-acre park features softball & baseball fields, plus basketball courts & a playground.",
      "poi_long_description": "People say this park features a large, shaded playground with a variety of equipment, including swings, slides, and monkey bars, as well as open spaces for parties and basketball courts. They also highlight the well-maintained grounds, ample parking, and clean restrooms. Visitors appreciate the peaceful atmosphere, making it great for walks, relaxation, and family gatherings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fc-f9f5-75c8-b762-464be200b898.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-f9f5-75c8-b762-464be200b898",
        "storage_key": "property/6767906449166301/019f14fc-f9f5-75c8-b762-464be200b898.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mesaparks.com/parks-facilities/parks/skyline-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10197136413886392251&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "skyline-park",
      "poi_latitude": "33.4023394",
      "poi_longitude": "-111.612391",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-644-4271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7fda-77bc-94e8-90c519f3ace0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7fda-77bc-94e8-90c519f3ace0",
        "storage_key": "property/6767906449166301/019d02c5-7fda-77bc-94e8-90c519f3ace0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyzJ-cP6wK4cRuyfmq4qBg40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_41b27d07-6a55-40b8-8d14-91a52ad92512",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Augusta Ranch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9455 E Neville Ave, Mesa, AZ 85209, USA",
      "poi_short_description": "Park with playgrounds and soccer fields as well as a basketball court and volleyball courts, plus BBQ grills.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fc-f92b-772d-b075-3493431f5ab7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-f92b-772d-b075-3493431f5ab7",
        "storage_key": "property/6767906449166301/019f14fc-f92b-772d-b075-3493431f5ab7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mesaaz.gov/Activities-Culture/Parks-Recreation-and-Community-Facilities/Parks-Facilities/Augusta-Ranch-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10221357821500453101&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "augusta-ranch-park",
      "poi_latitude": "33.3665449",
      "poi_longitude": "-111.6299271",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-644-2352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7fda-77bc-94e8-90c519f3ace0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7fda-77bc-94e8-90c519f3ace0",
        "storage_key": "property/6767906449166301/019d02c5-7fda-77bc-94e8-90c519f3ace0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcRSp5qxK4cR7fCxmMiO2Y0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_65d4273d-895d-4d32-805c-aebef0c51856",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Patterson School",
      "poi_type": "Education",
      "poi_address": "615 S Cheshire, Mesa, AZ 85208, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fc-f4d5-7379-a369-300e4f4e8ad0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-f4d5-7379-a369-300e4f4e8ad0",
        "storage_key": "property/6767906449166301/019f14fc-f4d5-7379-a369-300e4f4e8ad0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mpsaz.org/patterson",
      "poi_directions_map_url": "https://maps.google.com/?cid=4014307324206829100&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "patterson-school",
      "poi_latitude": "33.4032475",
      "poi_longitude": "-111.6047076",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-472-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab",
        "storage_key": "property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt32Jt-KwK4cRLM6YHj6vtTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3822f1ce-3265-4581-b9c8-9f28f26e90b4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Smith Junior High School",
      "poi_type": "Education",
      "poi_address": "10100 E Adobe Rd, Mesa, AZ 85207, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fc-f5f8-757f-b424-6a4905bdb59c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-f5f8-757f-b424-6a4905bdb59c",
        "storage_key": "property/6767906449166301/019f14fc-f5f8-757f-b424-6a4905bdb59c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mpsaz.org/smith",
      "poi_directions_map_url": "https://maps.google.com/?cid=12157645615385680424&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smith-junior-high-school",
      "poi_latitude": "33.4304105",
      "poi_longitude": "-111.6134382",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-472-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab",
        "storage_key": "property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD485JImwK4cRKBom8kWiuKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4749a053-fcfb-4bfe-9412-3ad6fb0f1def",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Skyline High School",
      "poi_type": "Education",
      "poi_address": "845 S Crismon Rd, Mesa, AZ 85208, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fc-f339-70ba-89b5-53a51fdbb639.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-f339-70ba-89b5-53a51fdbb639",
        "storage_key": "property/6767906449166301/019f14fc-f339-70ba-89b5-53a51fdbb639.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mpsaz.org/skyline",
      "poi_directions_map_url": "https://maps.google.com/?cid=750280823024035806&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "skyline-high-school",
      "poi_latitude": "33.3988008",
      "poi_longitude": "-111.6126105",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-472-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab",
        "storage_key": "property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ15UhxAGxK4cR3qci8m6IaQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5139a9a3-d547-4738-96ef-d2f27fc63cbb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "poi_name": "Arizona State University Polytechnic Campus",
      "poi_type": "Education",
      "poi_address": "7001 E Williams Field Rd, Mesa, AZ 85212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019f14fc-fa61-7451-8054-1c6607215c78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-fa61-7451-8054-1c6607215c78",
        "storage_key": "property/6767906449166301/019f14fc-fa61-7451-8054-1c6607215c78.webp",
        "width": 1080,
        "height": 758
      },
      "poi_business_url": "http://campus.asu.edu/polytechnic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3286714134695415506&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arizona-state-university-polytechnic-campus",
      "poi_latitude": "33.3060092",
      "poi_longitude": "-111.6785238",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-727-1585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab",
        "storage_key": "property/6767906449166301/019d02c5-7ad5-7767-8a4a-0eb5b0dc75ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-c0dQ52tK4cR0o7GfBfBnC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "ec_882d953c9be12875ecc73258",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ce82c8f951dce11c1de76d85",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_51738840e5e0e7dec977ed0b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fb0a899fe690a1cfa3fd8324",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a42cc406fd05188f20da1775",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6f5c96834db6a1ed68774fe4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_5d7c0c92-3294-4df8-a90e-c686b2d24acc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "rating": "5.0",
      "name": "Summer AZ",
      "text": "Great apartment complex to live in. Well maintained, no bugs, feels safe, and a beautiful large grass area I highly recommend getting an apartment in front of like we had. The view is beautiful and if you have kids it’s even better for them to easily play near home.\n\nWe lived here for just over 2yrs when it use to be Ascend and then Lumina took over about 3mo after we moved in. We have zero complaints over management and found they are professional and helpful.\n\nThe pool almost never has closures and is always clean. We had a few issues with our washer that maintenance handled in a reasonable time frame. Other then that, no issues in our 2yrs.",
      "date": "2025-08-08",
      "title": ""
    },
    {
      "id": "custom_ca77cf88-e9ce-4f24-ab4c-5a824a45fb79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "rating": "5.0",
      "name": "Michael Thomas",
      "text": "So I Scheduled my tour of these Apartments today, along with some of the others in the area. I had scheduled Lumina first as I was really impressed by its upkeep from outside. So I met with a Corrine, who is the manager there. No wonder why this lady is the manager, she knew everything including specials, and things to do in the community and surrounding stores. Even gave me Starbucks locations! So Corrine, made sure I had seen all the 2 bedroom apartment models as well as gave me some ideas on locations through out the community. I was really happy and excited to live there. I was really nervous that with all the free months rent that I was coming across in the area Corrine wouldn't find me a deal. I hate moving as in my last place I lived in those Apartments for 20 years . Well this is truly one Amazing lady. These apartments really impressed me. Thank you for the tour.",
      "date": "2024-08-29",
      "title": ""
    },
    {
      "id": "custom_e5b2e581-5d54-4d7f-8507-fccfe2270d72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "rating": "5.0",
      "name": "Thu",
      "text": "Lived at Lumina Mountain Vista for 2 years, since they completed construction of the property. It was a pleasant time, made wonderful by the exceptional staff who have always been helpful at the drop of a dime. Special shout outs to Christian and Angelica, who have always been of great resource and assistance, even weeks after I have moved out.",
      "date": "2025-08-26",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_7f4ba0c8-cb61-4511-8c4c-67cfc5aa206f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Modern 2-bedroom, 2-bathroom apartment in Mesa, AZ. Spacious 1075 sq. ft. layout with open-concept living area, sleek kitchen, and primary bedroom. Stylish finishes and ample storage throughout.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c6-be56-7119-a86d-3fb3a2df9bf8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019d02c6-be56-7119-a86d-3fb3a2df9bf8",
        "storage_key": "property/6767906449166301/019d02c6-be56-7119-a86d-3fb3a2df9bf8.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1075 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=WHnyYKZx21w"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019910d4-635c-721d-826c-bb13655a3268",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Lumina Mountain Vista property website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301"
    },
    {
      "lead_collector_id": "019910d4-63d1-77b0-812f-ea7b7301e08a",
      "lead_source": "FACEBOOK_ADS",
      "name": "Lumina Mountain Vista facebook ads",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301"
    },
    {
      "lead_collector_id": "019910d4-6441-75dd-9a1e-064514d95453",
      "lead_source": "LANDING_PAGE",
      "name": "Lumina Mountain Vista landing page",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-mesa-az",
      "search_query": "luxury apartments with pool Mesa AZ",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Mesa, AZ",
      "h2_subtitle": "Discover luxury living in Mesa, AZ, at Lumina Mountain Vista. Enjoy spacious apartments with a stunning pool and modern amenities.",
      "page_copy": "Welcome to Lumina Mountain Vista, your destination for luxury apartments with pool in Mesa, AZ. Nestled in the vibrant East Mesa community, our stunning complex offers a serene escape from the everyday hustle. Choose from our spacious one, two, or three-bedroom floor plans, each designed with elegance and comfort in mind. Our apartments boast gourmet kitchens and convenient walk-in closets, ensuring every convenience is at your fingertips.\n\nBeyond the comforts of your home, indulge in our first-class amenities that elevate the meaning of luxury living. Dive into relaxation at our sparkling pool, perfect for unwinding after a long day. Our fitness center invites you to maintain an active lifestyle, while the dog park offers a playful haven for your furry friends. At Lumina Mountain Vista, community events provide a platform for neighbors to connect and create lasting memories.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Mesa, AZ",
      "seo_description": "Experience luxury living at Lumina Mountain Vista in Mesa, AZ. Enjoy modern amenities and a stunning pool in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "dog-park-community-apartments-east-mesa",
      "search_query": "dog park community apartments East Mesa",
      "category": "Amenity",
      "h1_title": "Dog Park Community Apartments in East Mesa",
      "h2_subtitle": "Enjoy pet-friendly living in East Mesa with Lumina Mountain Vista. Our dog park community welcomes you and your furry friends.",
      "page_copy": "At Lumina Mountain Vista, we offer premier dog park community apartments in East Mesa, perfectly tailored for both you and your furry companions. Our pet-friendly environment boasts expansive spaces and amenities designed to make both you and your pets feel right at home. Choose from a selection of stylish one, two, or three-bedroom floor plans, all equipped with modern conveniences like gourmet kitchens and plush carpets.\n\nOur community is more than just a place to live, it’s a lifestyle. The on-site dog park facilitates play and exercise, creating the perfect setting for pets to socialize and stay active. Beyond the dog park, residents can engage in our various community activities designed to foster connections among neighbors. With amenities such as a refreshing pool, a state-of-the-art fitness center, and grilling areas, Lumina Mountain Vista promises a holistic living experience in East Mesa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Community Apartments in East Mesa",
      "seo_description": "Discover pet-friendly living in East Mesa at Lumina Mountain Vista. Enjoy a vibrant community and an on-site dog park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-maricopa-county",
      "search_query": "fitness center apartments in Maricopa County",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Maricopa County",
      "h2_subtitle": "Stay active at Lumina Mountain Vista in Maricopa County. Our apartments feature a state-of-the-art fitness center and modern amenities.",
      "page_copy": "Welcome to Lumina Mountain Vista, the epitome of fitness center apartments in Maricopa County. Located in the heart of East Mesa, our community offers a seamless blend of luxury and active living. Choose from spacious one, two, or three-bedroom floor plans, each equipped with contemporary features including gourmet kitchens and walk-in closets, tailored to fit your lifestyle.\n\nOur top-tier fitness center is a cornerstone of the community, providing residents with the convenience of maintaining an active lifestyle just steps from their door. Whether you're starting your fitness journey or maintaining a seasoned routine, our facility is designed to meet a variety of needs. Post-workout, relax by our inviting pool or socialize with neighbors at one of our community events. Lumina Mountain Vista is not just a place to live—it's a haven for those who value a balanced and vibrant lifestyle in Maricopa County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Maricopa County",
      "seo_description": "Discover vibrant living at Lumina Mountain Vista, Maricopa County. Enjoy a modern fitness center and luxury amenities in our apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-near-85209",
      "search_query": "in-unit laundry apartments near 85209",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments Near 85209",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at Lumina Mountain Vista, near 85209. Live comfortably with modern amenities at your fingertips.",
      "page_copy": "Discover the convenience of in-unit laundry apartments near 85209 at Lumina Mountain Vista in East Mesa. Our community offers a range of spacious one, two, and three-bedroom floor plans, each thoughtfully designed with modern comforts including in-unit laundry to make daily living effortless. Experience the luxury of gourmet kitchens and ample walk-in closets, enhancing your lifestyle at every turn.\n\nLumina Mountain Vista is more than just a convenient location—it's a community that values comfort and connection. Enjoy unwinding by our refreshing pool or working out in our fully equipped fitness center. Our property also offers a dog park and hosts regular social events, ensuring opportunities to mingle with neighbors and create a vibrant living experience. Situated near the 85209 area, Lumina Mountain Vista combines prime location with unparalleled amenities for an ideal living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Near 85209",
      "seo_description": "Live conveniently at Lumina Mountain Vista with in-unit laundry and modern amenities in East Mesa, near the 85209 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "dishwasher-equipped-rentals-mesa",
      "search_query": "dishwasher equipped rentals in Mesa",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Rentals in Mesa",
      "h2_subtitle": "Explore modern living with dishwasher-equipped rentals at Lumina Mountain Vista. Enjoy convenience and style in Mesa, AZ.",
      "page_copy": "Discover the ease of living in dishwasher-equipped rentals at Lumina Mountain Vista in Mesa, AZ. Our selection of one, two, and three-bedroom apartments are designed with your convenience in mind, featuring gourmet kitchens complete with modern dishwashers. Each floor plan ensures a seamless blend of style and functionality, making everyday tasks easier and leaving you more time to enjoy life.\n\nBeyond the kitchen, our community offers a variety of amenities aimed at enriching your lifestyle. Relax by our inviting swimming pool, keep fit in our state-of-the-art fitness center, or enjoy a leisurely day at our on-site dog park. With social activities planned for residents, Lumina Mountain Vista is a community that provides not just a home, but a vibrant environment in the heart of Mesa. Experience the perfect blend of convenience and comfort in our dishwasher-equipped rentals today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Equipped Rentals in Mesa",
      "seo_description": "Find convenience at Lumina Mountain Vista in Mesa with modern, dishwasher-equipped rentals and a host of amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-mesa-az",
      "search_query": "one bedroom apartments mesa az",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Mesa, AZ",
      "h2_subtitle": "Find your ideal one-bedroom apartment at Lumina Mountain Vista in Mesa, AZ. Enjoy modern amenities in a prime location.",
      "page_copy": "Welcome to Lumina Mountain Vista, where you'll find ideal one-bedroom apartments in Mesa, AZ. Our community offers spacious layouts designed to maximize comfort and efficiency. Each one-bedroom unit features modern amenities such as a fully equipped gourmet kitchen and ample walk-in closets, aligning style with convenience.\n\nLocated in the vibrant East Mesa neighborhood, Lumina Mountain Vista not only offers exceptional apartments but also a wealth of community features. Take advantage of our sparkling pool, energize at the fitness center, or mingle with fellow residents at our planned social gatherings. Perfectly situated in Mesa, AZ, our community ensures you're close to everything, from shopping and dining to picturesque outdoor activities. Experience elevated living in our thoughtfully designed one-bedroom apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Mesa, AZ",
      "seo_description": "Explore modern living at Lumina Mountain Vista with one-bedroom apartments offering luxury amenities in Mesa, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-maricopa-county",
      "search_query": "two bedroom apartments maricopa county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Maricopa County",
      "h2_subtitle": "Discover spacious two-bedroom apartments at Lumina Mountain Vista, located in Maricopa County. Enjoy luxury living with modern amenities.",
      "page_copy": "Nestled in the heart of Maricopa County, Lumina Mountain Vista offers exceptional two-bedroom apartments designed for comfort and style. Each apartment boasts spacious interiors, complete with modern amenities such as gourmet kitchens and large walk-in closets, making it the perfect choice for those seeking a luxurious living experience.\n\nBeyond the comforts of your apartment, our community provides a range of activities and facilities, from a refreshing swimming pool and a fully equipped fitness center to a welcoming dog park. Social activities are regularly planned, helping you connect with fellow residents and create a vibrant community atmosphere. Situated in the vibrant area of East Mesa, our two-bedroom apartments place you close to shops, dining, and outdoor attractions, delivering the perfect blend of convenience and tranquility in Maricopa County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Maricopa County",
      "seo_description": "Find luxury living at Lumina Mountain Vista with two-bedroom apartments offering modern amenities in Maricopa County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-east-mesa",
      "search_query": "three bedroom apartments in east mesa",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in East Mesa",
      "h2_subtitle": "Explore spacious three-bedroom apartments at Lumina Mountain Vista, located in the vibrant community of East Mesa.",
      "page_copy": "For those seeking ample space and modern conveniences, Lumina Mountain Vista offers three-bedroom apartments in East Mesa that perfectly blend comfort with style. Each unit is designed with family living in mind, featuring expansive layouts, gourmet kitchens, and generous walk-in closets. These thoughtfully designed apartments cater to the needs of those desiring a bit more room without compromising on luxury.\n\nLiving in East Mesa means you're part of a dynamic community with access to top-tier amenities at Lumina Mountain Vista. Whether it’s enjoying a barbecue at our grill stations, keeping active in our fitness center, or simply taking a dip in the pool, there’s something for everyone. And with nearby local attractions, dining, and shopping, our location ensures you have everything you need right at your doorstep. Experience enhanced living today in our beautifully crafted three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in East Mesa",
      "seo_description": "Discover spacious three-bedroom apartments at Lumina Mountain Vista with modern amenities in the heart of East Mesa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "apartments-near-mesa-community-college-red-mountain-campus",
      "search_query": "apartments near Mesa Community College Red Mountain Campus Mesa",
      "category": "School",
      "h1_title": "Apartments Near Mesa Community College",
      "h2_subtitle": "Find the perfect home near the Red Mountain Campus of Mesa Community College. Experience luxurious apartment living at Lumina Mountain Vista.",
      "page_copy": "Convenience and comfort converge at Lumina Mountain Vista, ideally situated near Mesa Community College's Red Mountain Campus. Our apartments provide students and professionals alike with spacious accommodations featuring modern amenities like gourmet kitchens and ample walk-in closets. This makes Lumina Mountain Vista a top choice for anyone looking to live close to the college.\n\nApart from prime proximity, residents of Lumina Mountain Vista enjoy access to a variety of community features. Relax by the pool, maintain your fitness routine in our state-of-the-art gym, or socialize with neighbors during our organized activities. All these amenities, paired with the advantage of living close to Mesa Community College's Red Mountain Campus, make our apartments an excellent choice for a balanced and convenient lifestyle in Mesa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mesa Community College",
      "seo_description": "Explore luxury living at Lumina Mountain Vista, offering apartments near Mesa Community College's Red Mountain Campus in Mesa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "apartments-near-banner-baywood-medical-center-mesa",
      "search_query": "apartments near banner baywood medical center mesa az",
      "category": "Hospital",
      "h1_title": "Apartments Near Banner Baywood Medical Center",
      "h2_subtitle": "Live close to Banner Baywood Medical Center in Mesa, AZ. Discover comfortable apartment living at Lumina Mountain Vista.",
      "page_copy": "Positioned conveniently near Banner Baywood Medical Center in Mesa, AZ, Lumina Mountain Vista offers prime apartment living for medical professionals and those seeking proximity to top healthcare services. Our community features thoughtfully designed one, two, and three-bedroom floor plans, complete with modern amenities like gourmet kitchens and spacious walk-in closets, catering to the diverse needs of our residents.\n\nLumina Mountain Vista doesn't just offer a place to live, but a vibrant community atmosphere. Residents can enjoy refreshing dips in our pool, engage in a workout in our well-equipped fitness center, or bring their furry friends to our dog park. Additionally, with easy access to Banner Baywood Medical Center and a variety of shopping and dining options, living here provides the perfect blend of convenience and lifestyle in the heart of Mesa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Banner Baywood Medical Center, Mesa",
      "seo_description": "Discover apartments near Banner Baywood Medical Center in Mesa, AZ. Experience luxury living at Lumina Mountain Vista.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "apartments-close-to-honorhealth-mountain-vista-medical-center",
      "search_query": "apartments close to honorhealth mountain vista medical center east mesa",
      "category": "Hospital",
      "h1_title": "Apartments Close to HonorHealth Mountain Vista",
      "h2_subtitle": "Discover apartments just moments from HonorHealth Mountain Vista Medical Center, right here in East Mesa.",
      "page_copy": "At Lumina Mountain Vista, you're just a stone's throw away from the HonorHealth Mountain Vista Medical Center, an ideal location for healthcare professionals and residents seeking convenience. Our community offers a range of spacious apartments, from one to three-bedroom layouts, each featuring high-quality finishes and modern amenities like gourmet kitchens and generous walk-in closets.\n\nBeyond individual apartment features, Lumina Mountain Vista boasts a vibrant community with a variety of amenities. Enjoy our sparkling pool, well-equipped fitness center, and lively social gatherings, all designed to foster connections and relaxation. Situated in East Mesa, you'll have quick access not only to HonorHealth Mountain Vista Medical Center but also nearby shopping and dining options, making it a perfect location for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to HonorHealth Mountain Vista",
      "seo_description": "Live near HonorHealth Mountain Vista Medical Center in East Mesa at Lumina Mountain Vista. Explore luxury apartment living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "apartments-near-usery-mountain-regional-park",
      "search_query": "apartments near usery mountain regional park mesa",
      "category": "Park",
      "h1_title": "Apartments Near Usery Mountain Park",
      "h2_subtitle": "Discover the perfect home near Usery Mountain Regional Park in Mesa. Enjoy apartment living at Lumina Mountain Vista.",
      "page_copy": "At Lumina Mountain Vista, experience the best of desert living with the stunning Usery Mountain Regional Park just a short drive away. Perfect for nature lovers and outdoor enthusiasts, our community offers easy access to the park's scenic trails and breathtaking vistas, making it an ideal location for those who love to explore the great outdoors.\n\nOur spacious one, two, and three-bedroom apartments feature modern amenities, including gourmet kitchens and ample storage with walk-in closets. Residents of Lumina Mountain Vista can also enjoy community perks such as a refreshing pool, state-of-the-art fitness center, and engaging social events. Situated in Mesa, you’ll be close to both the tranquil beauty of Usery Mountain Regional Park and the vibrant local downtown scene.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Usery Mountain Regional Park",
      "seo_description": "Find your new home near Usery Mountain Regional Park at Lumina Mountain Vista. Explore nature and live in comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "lumina-apartments-close-to-red-mountain-park",
      "search_query": "lumina apartments close to red mountain park east mesa",
      "category": "Park",
      "h1_title": "Lumina Apartments Near Red Mountain Park",
      "h2_subtitle": "Explore Lumina Apartments close to Red Mountain Park in East Mesa. Enjoy nature at your doorstep.",
      "page_copy": "Lumina Mountain Vista offers ideal apartment living with close proximity to the scenic Red Mountain Park in East Mesa. This location is perfect for those who love outdoor activities, as the park provides a variety of recreational options, including hiking trails and picturesque picnic areas. At Lumina, you can relish both comfort and adventure.\n\nChoose from our well-appointed one, two, or three-bedroom apartments, equipped with modern features like gourmet kitchens and expansive walk-in closets. The community at Lumina Mountain Vista also boasts amenities such as a sparkling pool and a fitness center. With Red Mountain Park and local amenities just minutes away, Lumina delivers the perfect blend of nature and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lumina Apartments Near Red Mountain Park",
      "seo_description": "Discover Lumina Apartments near Red Mountain Park in East Mesa. Experience the best of comfortable and adventurous living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166301",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-near-painted-sky-park",
      "search_query": "apartments pet-friendly near painted sky park maricopa county",
      "category": "Park",
      "h1_title": "Pet-Friendly Apartments by Painted Sky Park",
      "h2_subtitle": "Find pet-friendly apartments near Painted Sky Park in Maricopa County. Welcome home to Lumina Mountain Vista.",
      "page_copy": "At Lumina Mountain Vista, enjoy pet-friendly living near the beautiful Painted Sky Park in Maricopa County. Our community is designed with both you and your furry friends in mind, offering convenient access to the park's open spaces and walking trails that cater to your active lifestyle. Soak up the natural beauty while taking leisurely strolls or playing fetch with your dog.\n\nChoose from spacious one, two, and three-bedroom floor plans, each equipped with modern amenities such as gourmet kitchens and large walk-in closets. Beyond the comfort of your home, Lumina Mountain Vista provides a range of community features, including an inviting pool, a well-equipped fitness center, and a dedicated dog park, ensuring pets feel as welcome as their owners.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019d02c5-1dcd-7701-9f53-687ac8833bf1",
        "storage_key": "property/6767906449166301/019d02c5-1dcd-7701-9f53-687ac8833bf1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments by Painted Sky Park",
      "seo_description": "Explore pet-friendly living at Lumina Mountain Vista near Painted Sky Park in Maricopa County. Perfect for you and your furry friend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5311"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425808"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=e679df72724c934073116a3fc299ed5f972dc60937fe0a535b58641c6f67c31cc6549e3227136404329710825fa87940\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N6L8Q8KS"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "283LMV"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40255796363"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Lumina Mountain Vista/scheduletourwidget/l23lFHYXD98GQqhfMI/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imt4a3J6Nk15dVRpQ1ZGK2N5Ui9ZZmc9PSIsInZhbHVlIjoiSElqZDdmL0t5dHZ1VStPL20zRlh6UT09IiwibWFjIjoiOTViMzNlOTU3ODFjYjViNjk5ZWE3ZjRiNWRjYmY5ZmFkNzA5MWJmODFlYjUyYWFkYzA4ODZhNzA1MDIxOWFhOCJ9"
    }
  ],
  "custom_qb_id": "5311",
  "custom_repli_id": "18104425808",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=e679df72724c934073116a3fc299ed5f972dc60937fe0a535b58641c6f67c31cc6549e3227136404329710825fa87940\"></script>",
  "custom_google_gtm_id": "GTM-N6L8Q8KS",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "283LMV",
  "custom_hubspot_company_id": "40255796363",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Lumina Mountain Vista/scheduletourwidget/l23lFHYXD98GQqhfMI/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imt4a3J6Nk15dVRpQ1ZGK2N5Ui9ZZmc9PSIsInZhbHVlIjoiSElqZDdmL0t5dHZ1VStPL20zRlh6UT09IiwibWFjIjoiOTViMzNlOTU3ODFjYjViNjk5ZWE3ZjRiNWRjYmY5ZmFkNzA5MWJmODFlYjUyYWFkYzA4ODZhNzA1MDIxOWFhOCJ9",
  "custom_audioeye_site_id": "8f8130a6-7d01-413a-8738-c8dad2f056d0",
  "custom_audioeye_site_hash": "5c6c08f24a98d488d0f0d8685000f30e"
};

export const generatedAt = '2026-08-21T22:00:29.120Z';
